import { PeopleInChatStore } from '../store/message/peopleInChat.store';
import { MessageStore } from '../store/message/message.store';
import { ConversationRootStore } from '../store/conversation-root.store';
import { configure } from 'mobx';
configure({ enforceActions: 'never' });
var ConversationSetup = (function () {
    function ConversationSetup() {
    }
    Object.defineProperty(ConversationSetup, "createStore", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (hidePeopleInChat, uploadFileSizeLimit, fileExtensions) {
            var peopleInChatStore = new PeopleInChatStore({
                shouldHidePeopleInChat: hidePeopleInChat
            });
            var messageStore = new MessageStore({
                fileSizeLimit: +uploadFileSizeLimit,
                fileExtensions: fileExtensions,
                peopleInChatStore: peopleInChatStore
            });
            var conversationRootStore = new ConversationRootStore(messageStore);
            return conversationRootStore;
        }
    });
    return ConversationSetup;
}());
export { ConversationSetup };
